const url_product = `https://b2ev93bp71.execute-api.us-east-1.amazonaws.com/dev`;
const url_table = `https://b6jafdtbwg.execute-api.us-east-1.amazonaws.com/dev`;
const url_order = `https://p9fqpzdvxj.execute-api.us-east-1.amazonaws.com/dev`;
const url_company = `https://0j6apqtv0c.execute-api.us-east-1.amazonaws.com/dev`;
const url_shopping = `https://3l97bepsle.execute-api.us-east-1.amazonaws.com/dev`;
const url_person = `https://rap3jri8b6.execute-api.us-east-1.amazonaws.com/dev`

export const environment = {
  production: false,
  apis: {
    product: {
      SEARCH: `${url_product}/rst/service-product/brand/list-search`,
      POST: `${url_product}/rst/service-product/brand/create`,
      PUT: `${url_product}/rst/service-product/brand/edit`,
      GET_ID: `${url_product}/rst/service-product/brand/list`,
    },
    category: {
      SEARCH: `${url_product}/rst/service-product/category/list-search`,
      POST: `${url_product}/rst/service-product/category/create`,
      PUT: `${url_product}/rst/service-product/category/edit`,
      GET_ID: `${url_product}/rst/service-product/category/list`,
    },
    products: {
      SEARCH: `${url_product}/rst/service-product/product/list-search`,
      POST: `${url_product}/rst/service-product/product/create`,
      PUT: `${url_product}/rst/service-product/product/edit`,
      GET_ID: `${url_product}/rst/service-product/product/list`,
      GET_BY_CATEGORY: `${url_product}/rst/service-product/product/list-by-category`,
      GET_BY_TYPES: `${url_product}/rst/service-product/product/list-by-types`,
      GER_BY_PROTYPE: `${url_product}/rst/service-product/product/list-by-types`,
    },
    productType: {
      SEARCH: `${url_product}/rst/service-product/product-type/list-search`,
      POST: `${url_product}/rst/service-product/product-type/create`,
      PUT: `${url_product}/rst/service-product/product-type/edit`,
      GET_ID: `${url_product}/rst/service-product/product-type/list`,
    },
    table: {
      SEARCH: `${url_table}/rst/service-table/table/list-search`,
      GET_ALL: `${url_table}/rst/service-table/table/list-all`,
      POST: `${url_table}/rst/service-table/table/create`,
      PUT: `${url_table}/rst/service-table/table/edit`,
      GET_ID: `${url_table}/rst/service-table/table/list`,
    },
    login: {
      SIGN_IN: `${url_company}/rst/service-user/auth/signin`,
      CURRENT_USER: `${url_company}/rst/service-user/auth/current_user`,
      REFRESH_TOKEN: `${url_company}/rst/service-user/auth/refresh-token`,
    },
    user: {
      SIGN_UP: `${url_company}/rst/service-user/auth/signup`,
      SEARCH: `${url_company}/rst/service-user/user/list-search`,
      GET_ID: `${url_company}/rst/service-user/user/list`,
      GET: `${url_company}/rst/service-user/user/get`,
      GET_NAMES: `${url_company}/rst/service-user/user/list-names`,
      POST: `${url_company}/rst/service-user/user/create`,
      PUT: `${url_company}/rst/service-user/user/edit`,
    },
    location: {
      SEARCH: `${url_company}/rst/service-company/location/list-search`,
      LIST_NAMES: `${url_company}/rst/service-company/location/list-names`,
      //GET_ID: `${url_company}/rst/service-company/location/list`,
      GET: `${url_company}/rst/service-company/location/get`,
      POST: `${url_company}/rst/service-company/location/create`,
      PUT: `${url_company}/rst/service-company/location/edit`,
    },
    order: {
      SEARCH: `${url_order}/rst/service-order/order/list-search`,
      GET_ID: `${url_order}/rst/service-order/order/list`,
      POST: `${url_order}/rst/service-order/order/create`,
      PUT: `${url_order}/rst/service-order/order/edit`,
      GET_ID_TABLE: `${url_order}/rst/service-order/order/get-by-table`,
      PAY: `${url_order}/rst/service-order/order/pay`,
      GET_PDF: `${url_order}/rst/service-order/order/note-sale-url`,
      GET_EXPORT_PDF_DATE_BETWEEN: `${url_order}/rst/service-order/s3/report-pdf/date-between`,
      GET_EXPORT_PDF_DATE_SPECIFIC: `${url_order}/rst/service-order/s3/report-pdf/date-specific`,
      GET_EXPORT_PDF_DATE_TOTAL: `${url_order}/rst/service-order/s3/report-pdf/date-total`,
      GET_EXPORT_PDF_DATE_BETWEEN_WAITER: `${url_order}/rst/service-order/s3/report-pdf/waiter/date-between`,
      GET_EXPORT_PDF_DATE_SPECIFIC_WAITER: `${url_order}/rst/service-order/s3/report-pdf/waiter/date`,
      GET_EXPORT_PDF_DATE_TOTAL_WAITER: `${url_order}/rst/service-order/s3/report-pdf/waiter`,
      GET_EXPORT_EXCEL_DATE_BETWEEN: `${url_order}/rst/service-order/s3/report-excel/date-between`,
      GET_EXPORT_EXCEL_DATE_SPECIFIC: `${url_order}/rst/service-order/s3/report-excel/date-specific`,
      GET_EXPORT_EXCEL_DATE_TOTAL: `${url_order}/rst/service-order/s3/report-excel/date-total`,
    },
    command: {
      list: `${url_order}/rst/service-order/command/list`,
    },
    company:{
      SEARCH: `${url_company}/rst/service-company/company/list-search`,
      GET_RUC: `${url_company}/rst/service-company/company/document`,
      GET_ID: `${url_company}/rst/service-company/company/list`,
      POST: `${url_company}/rst/service-company/company/create`,
      PUT: `${url_company}/rst/service-company/company/edit`,
    },
    shopping:{
      POST: `${url_shopping}/ace/api/purchase`,
      SEARCH: `${url_shopping}/ace/api/purchase/list-all`,
      GET_ID: `${url_shopping}/ace/api/purchase`,
      PUT: `${url_shopping}/ace/api/purchase`,
    },
    supplies:{
      GET_LIST: `${url_shopping}/ace/api/purchase/products-by-purchase`,
      GET_DETAIL: `${url_shopping}/ace/api/purchase/history-by-product`,
    },
    person:{
      POST:`${url_person}/ace/api/person`,
      SEARCH: `${url_person}/ace/api/person/list-all`,
      PUT: `${url_person}/ace/api/person`,
      GET_ID: `${url_person}/ace/api/person`,
    }
  },
};
